const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
    lista: [], 
    listaUsuario: [],
    listaTipo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'OCORRENCIA_LOGISTICA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'OCORRENCIA_LOGISTICA_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'OCORRENCIA_LOGISTICA_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaUsuario: action.payload.data
            };

        case 'OCORRENCIA_LOGISTICA_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaTipo: action.payload.data
            };
                      
        default:
            return state;
    }
}
